import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "@/design/tokens.stylex";
import { colors, radii, space, text } from "@/design/tokens.stylex";

// A status word in a soft pill: Pending, Failed, Live. Colour supports the
// word; it never carries the meaning alone.
export type BadgeTone = "neutral" | "success" | "warning" | "danger" | "info";
const styles = {
  badge: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kOIVth: "xsuxsxl",
    kZKoxP: "x1qx5ct2",
    kg3NbH: "x1wa2ap4",
    kaIpWk: "x1wpy2cq",
    kGuDYH: "x1hqrb6m",
    k63SB2: "xk50ysn",
    kLWn49: "xo5v014",
    khDVqt: "xuxw1ft",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    $$css: true
  },
  neutral: {
    kWkggS: "xlcwlql",
    kVAM5u: "xsf2n63",
    kMwMTN: "x1e3avs9",
    $$css: true
  },
  success: {
    kWkggS: "x1ephxz2",
    kVAM5u: "x1kuvxft",
    kMwMTN: "x1628k4o",
    $$css: true
  },
  warning: {
    kWkggS: "x1i5inb7",
    kVAM5u: "x181yoh8",
    kMwMTN: "xnclacp",
    $$css: true
  },
  danger: {
    kWkggS: "x1h1f4i9",
    kVAM5u: "x3mpidx",
    kMwMTN: "x1nif09i",
    $$css: true
  },
  info: {
    kWkggS: "x1h1f4i9",
    kVAM5u: "xzbo3x7",
    kMwMTN: "x1e3avs9",
    $$css: true
  }
};
export interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  title?: string;
  xstyle?: stylex.StyleXStyles;
}
export default function Badge({
  children,
  tone = "neutral",
  title,
  xstyle
}: BadgeProps) {
  return <span title={title} {...stylex.props(styles.badge, styles[tone], xstyle)}>
      {children}
    </span>;
}